import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'rinCostChange';
const word = 'new RIN cost';

export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			successMessage: `The ${word} was created successfully.
				Refresh to see the new value in the list or the formula page.`,
			onSuccessRedirectTo: `/formulas/rinCostChanges`,
			callback,
		});
	};
};

const mapStateToProps = (state) => {
	let rinCostChanges;

	const canRwRinCost = !!_.get(state.auth.authUser, ['permissions', 'canRwRinCost'], false);

	if (state.lists.rinCostChangeIds) {
		rinCostChanges = _.map(
			state.lists.rinCostChangeIds,
			(id) => state.maps.rinCostChange[id]
		);
	}
	return {
		canRwRinCost,
		rinCostChanges,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			rinCostChangeSearch: search,
			rinCostChangeAdd: add,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
